'use client'
import React from 'react'

export const IndentIncreaseIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.5 5H9.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M17.5 10H9.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M17.5 15H2.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.75 7.25L2.75 3.75V10.75L7.75 7.25Z" fill="currentColor" />
  </svg>
)
